import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class TotalRevenueQuery extends UncubesQuery {
  projection = 'ticket_sales'

  cuts = []

  aggregates = [{ kpi: 'ticket_line_amount', function: 'SUM' }]

  limit = 25

  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged) {
    super();
    this.cuts = [
      { expression: `point_of_sale_guid = '${pointOfSaleGuid}'` },
      { expression: `ticket_line_date between '${dateStart}' and '${dateEnd}'` }];
    if (isManaged) {
      this.cuts.push({ expression: "product_is_revenue_managed = 'True'" });
    }
  }
}
